import PropTypes from 'prop-types';

const FullPallet = ({ fill, width, height }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
    preserveAspectRatio="xMidYMid meet"
    width={width}
    height={height}
  >
    <g transform="translate(0.000000,34.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
      <path d="M107 333 c-4 -3 -7 -28 -7 -55 l0 -48 71 0 70 0 -3 53 c-3 45 -6 52 -25 55 -18 3 -23 -2 -23 -17 0 -14 -6 -21 -20 -21 -13 0 -20 7 -20 20 0 20 -28 28 -43 13z" />
      <path d="M20 140 l0 -50 70 0 70 0 0 50 c0 46 -2 50 -24 50 -15 0 -26 -7 -29 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 8 -16 20 0 15 -7 20 -25 20 -23 0 -25 -3 -25 -50z" />
      <path d="M180 140 l0 -50 70 0 70 0 0 50 c0 47 -2 50 -25 50 -18 0 -25 -5 -25 -20 0 -12 -7 -20 -16 -20 -9 0 -18 9 -21 20 -3 13 -14 20 -29 20 -22 0 -24 -4 -24 -50z" />
      <path d="M2 33 c2 -23 9 -29 34 -31 25 -2 33 1 37 17 7 27 43 28 50 1 8 -29 86 -29 94 0 7 27 43 26 50 -1 4 -16 12 -19 37 -17 25 2 32 8 34 31 l3 27 -171 0 -171 0 3 -27z" />
    </g>
  </svg>
);

export default FullPallet;

FullPallet.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

FullPallet.defaultProps = {
  fill: '#000',
  width: '100%',
  height: '100%'
};
